"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaterPointIcon = WaterPointIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function WaterPointIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.75 2C15.2555 5.47928 18.5 9.61059 18.5 13.3083C18.5 17.0061 15.4761 20 11.75 20C8.02389 20 5 17.0057 5 13.3083C5 9.61102 8.24455 5.47928 11.75 2ZM15.7023 12.5421C15.4858 12.5227 15.2721 12.5906 15.1208 12.7264C14.9682 12.8621 14.8974 13.0513 14.9252 13.2404C15.0959 14.4817 13.9454 16.2638 12.4717 16.9645C12.1247 17.1269 11.9957 17.5052 12.183 17.8083C12.3703 18.1101 12.8019 18.2229 13.1489 18.0604C15.1736 17.0966 16.6016 15.0285 16.3352 13.0949C16.3005 12.8027 16.0367 12.5724 15.7023 12.5421Z",
    fill: "currentColor"
  }));
}